import { z } from "zod";
import { journeyStepIdSchema } from "./steps.js";
export const slotSchema = z.enum(["pinned", "primary", "secondary", "footer"]);
export const chatUnreadBlockSchema = z.object({
    id: z.string(),
    type: z.literal("chatUnread"),
    slot: slotSchema,
    unreadCount: z.number().int().nonnegative(),
});
// Home's two ways in, until one is started: the initial assessment or
// straight to infusion. No payload — the copy is the client's.
export const pathChooserBlockSchema = z.object({
    id: z.string(),
    type: z.literal("pathChooser"),
    slot: slotSchema,
});
// The newest questionnaire summary is ready to open. Ids and a timestamp only.
export const summaryReadyBlockSchema = z.object({
    id: z.string(),
    type: z.literal("summaryReady"),
    slot: slotSchema,
    summaryId: z.string(),
    submittedAt: z.string(),
});
// US only: the welcome card, naming the first coaching step not yet done.
// Booking is never marked done yet (nothing reports a booked call), so it is
// where this block rests.
export const coachingNextStepBlockSchema = z.object({
    id: z.string(),
    type: z.literal("coachingNextStep"),
    slot: slotSchema,
    step: journeyStepIdSchema,
});
// The care team's active actions marked "shown in app". Care text is fetched
// by the block from GET /client/plan, never carried on home.
export const planBlockSchema = z.object({
    id: z.string(),
    type: z.literal("plan"),
    slot: slotSchema,
});
export const knownHomeBlockSchema = z.discriminatedUnion("type", [
    chatUnreadBlockSchema,
    pathChooserBlockSchema,
    summaryReadyBlockSchema,
    coachingNextStepBlockSchema,
    planBlockSchema,
]);
// Forward-compatibility, same rationale as readBlockSchema in chat.ts: a new
// server block type must not crash an old PWA holding a stale cache.
export const readHomeBlockSchema = z.union([knownHomeBlockSchema, z.object({ type: z.string() }).passthrough()]);
// Mirrors HOME_PHASES (journey/phase.ts). Kept as a separate literal list,
// not an import, since api-contract must not depend on apps/api.
export const homePhaseSchema = z.enum([
    "default",
    "awaiting_draw",
    "sampled",
    "result_ready",
    "second_result",
    "raising_started",
    "not_now",
    // Infusion track (journey/phase.ts).
    "lead",
    "screener",
    "labs_pending",
    "ready_to_book",
]);
export const homeSurfaceSchema = z.object({
    // Opaque to the client: it must never branch on this. Carried for
    // analytics only.
    stage: z.string(),
    // Presentational projection of stage, derived server-side (see
    // journey/phase.ts). .catch("default") is the read-lenient rule applied to
    // an enum: a newer server phase must not crash an older PWA holding a
    // stale cache — same rationale as readHomeBlockSchema above.
    phase: homePhaseSchema.catch("default"),
    blocks: z.array(readHomeBlockSchema),
});
